export default __webpack_public_path__ + "static/trama_bg@2x.png";